import { render, staticRenderFns } from "./CreatePaymentReceipt.vue?vue&type=template&id=574e0cc9&scoped=true&"
import script from "./CreatePaymentReceipt.vue?vue&type=script&lang=js&"
export * from "./CreatePaymentReceipt.vue?vue&type=script&lang=js&"
import style0 from "./CreatePaymentReceipt.vue?vue&type=style&index=0&id=574e0cc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e0cc9",
  null
  
)

export default component.exports